module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "first",
    staticClass: "first"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('video', {
    attrs: {
      "id": "video",
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/video/Weleda.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/static/video/Weleda.ogg",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask-video"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pare-el"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "center animation3"
  }, [_c('route-item', {
    staticClass: "next",
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go down')
      }
    }
  })], 1)]), _vm._v(" "), _c('Form', {
    attrs: {
      "showForm": _vm.showForm
    },
    on: {
      "closeForm": _vm.close
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center animation1"
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                МОЁ ДРУГОЕ ЛЕТО\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center animation2"
  }, [_c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                Профессиональная сноубордистка и путешественница Оля Смешливая вместе с натуральной косметикой Weleda приглашают в удивительное приключение по красивейшим местам Европы.\n                Узнайте, как получить новый опыт, зарядиться энергией природы и насладиться свежим горным воздухом.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ba6caca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/first.vue
// module id = 546
// module chunks = 1